<div class="row">
  <div [ngClass]="isShowRegisterBlock() ? 'col-7' : 'col-12'"
    class="col-sm-12">
    <div class="login-block">
      <h1>Log in</h1>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm.value)">
        @if (formError) {
          <div class="form-row">
            <div class="form-input-container">
              <p class="form-input-error"
                i18n="Login Error@@login.form.error">Login failed. Check your username/password.
						</p>
            </div>
          </div>
        }

        @if (!hasAcceptedCookies()) {
          <div class="form-row">
            <div class="form-input-container">
              <p class="form-input-error"
                i18n="Cookie Banner Accept cookies message@@cookies.not.accepted.message">
							Please accept our cookies to be able to log in. You can do this by clicking this link:
							<a [href]="cookieStatementUrl"
							   target="_blank">Go to cookie statement</a>
						</p>
            </div>
          </div>
        }

        <div class="form-row">
          <label class="form-label" for="email" i18n="Login form: e-mail label@@login.form.email">
						E-mail
					</label>

          <div class="form-input-container">
            <input [formControl]="loginForm.controls['email']"
              autocomplete="off"
              id="email"
              name="email"
              required
              title="Please enter your E-mail"
              type="email" />

            @if (!loginForm.controls['email'].valid) {
              @if (loginForm.controls['email'].hasError('required')
                && loginForm.controls['email'].touched) {
                <p
                  class="form-input-error"
                  i18n="Error: enter e-mail@@login.form.error.email.empty">
								Please enter an email address
							</p>
              }
              @if (loginForm.controls['email'].hasError('incorrectMailFormat')
                && loginForm.controls['email'].touched
                && !loginForm.controls['email'].hasError('required')) {
                <p
                  class="form-input-error"
                  i18n="Error: enter valid e-mail@@login.form.error.email">
								Please enter a valid email address
							</p>
              }
            }
          </div>
        </div>

        <div class="form-row">
          <label class="form-label" for="password" i18n="password label@@login.form.password">
						Password
					</label>

          <div class="form-input-container">
            <input [formControl]="loginForm.controls['password']"
              attr.type="{{passwordFieldType}}"
              id="password"
              name="password"
              required
              title="Please enter a password" />

            <button (click)="togglePassword()"
              class="form-show-password"
              type="button">

              <svg class="icon-eye" height="13" viewBox="0 0 18 13" width="18">
                <use xlink:href="/images/icons/svg-sprite.svg#eye"></use>
              </svg>
            </button>

            @if (loginForm.controls['password'].hasError('required')
              && loginForm.controls['password'].touched) {
              <p
                class="form-input-error"
                i18n="Error: enter password@@login.form.error.password.empty">Please enter password
						</p>
            }

            <div class="form-forgot-password">
              <a href="{{shopForgotPasswordUrl}}" i18n="forgot password text@@login.form.forgot.password">
								Forgot password?
							</a>
            </div>
          </div>
        </div>

        <div class="button-bar button-bar--right button-bar--mobile-block">
          <button [disabled]="!hasAcceptedCookies() || !loginForm.valid"
            class="button theme-btn-secondary"
            i18n="Log in@@login.form.button"
            type="submit">
						Log in
					</button>
        </div>
      </form>
    </div>
  </div>

  @if (isShowRegisterBlock()) {
    <div
      class="col-5 col-sm-12">
      <div class="login-block login-block--register">
        <h2 i18n="Login page: become a customer@@login.page.become.customer">
				Become a customer of Noviflora?
			</h2>
        <p i18n="Login page: register and receive info@@login.page.register.text">
				Register and receive login information
			</p>
        <div class="button-bar button-bar--mobile-block">
          <a class="button button--secondary theme-btn-secondary-outline"
            href="{{applicationService.getRegisterUrl()}}"
            i18n="register link@@login.page.register.link">Register
				</a>
        </div>
      </div>
    </div>
  }
</div>
